import { History as HistoryIcon } from 'lucide-react';
import { Link } from 'react-router';
import { paths } from '@/app/paths';

export function HistoryShortcut({ count }: { count: number }) {
  if (count === 0) return null;
  return (
    <div className="bg-white border border-slate-200 rounded-2xl p-4 shadow-xs flex items-center justify-between gap-4">
      <div className="flex items-center gap-3">
        <div className="w-9 h-9 rounded-xl bg-slate-100 text-slate-700 flex items-center justify-center">
          <HistoryIcon className="w-5 h-5 text-blue-600" />
        </div>
        <div>
          <h3 className="text-xs font-bold text-slate-800">
            {count} Saved {count === 1 ? 'Generation' : 'Generations'} in Log
          </h3>
          <p className="text-[11px] text-slate-500">
            View cost per render model, filter by date range, or reload past palettes.
          </p>
        </div>
      </div>
      <Link
        to={paths.history}
        className="px-3.5 py-2 bg-slate-900 hover:bg-slate-800 text-white text-xs font-bold rounded-xl transition-all shadow-xs whitespace-nowrap"
      >
        View History
      </Link>
    </div>
  );
}
